import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export const dayJsExt = dayjs;

export function getUtcOffsetString(d: Date = new Date()): string {
  const mins = -d.getTimezoneOffset();
  const sign = mins >= 0 ? "+" : "-";
  const abs = Math.abs(mins);
  const hh = String(Math.floor(abs / 60)).padStart(2, "0");
  const mm = String(abs % 60).padStart(2, "0");
  return `${sign}${hh}:${mm}`;
}

export function GetDateTime(
  datetime: Date = new Date(),
  timeZone: string = "Australia/Sydney"
): Dayjs {
  return dayJsExt(datetime).tz(timeZone);
}

export function GetDateTimeFormatted(
  datetime: Date = new Date(),
  timeZone: string = "Australia/Sydney"
): string {
  return GetDateTime(datetime, timeZone).format("YYYY-MM-DDTHH:mm:ssZ");
}

export function getPreviousBusinessDay(fromDate: Date): Date {
  const date = new Date(fromDate);
  do {
    date.setDate(date.getDate() - 1); 
  } while (date.getDay() === 0 || date.getDay() === 6); 

  return date;
}


export function ProcessExcelAsOf(asOf: string | number | Date): string {
  const myDate = GetDate(asOf);

  if (myDate.getHours() == 0 && myDate.getMinutes() == 0 && myDate.getSeconds() == 0)
    myDate.setHours(23, 59, 59);

  return GetDateTimeFormatted(myDate);
}

export function GetDate(v: string | number | Date): Date {
  if (v instanceof Date) return new Date(v);

  if (typeof v === "number") return excelSerialToDate(v);

  if (typeof v === "string" && /^\s*\d+(\.\d+)?\s*$/.test(v)) return excelSerialToDate(Number(v));

  const d = new Date(v as string);
  if (!Number.isNaN(d.getTime())) return d;

  throw new Error("Unsupported asOf value");
}

function excelSerialToDate(serial: number): Date {
  const msPerDay = 24 * 60 * 60 * 1000;
  const epoch1900 = new Date(1899, 11, 31).getTime();
  const adjust = serial >= 60 ? -1 : 0;
  return new Date(epoch1900 + (serial + adjust) * msPerDay);
}
